module.exports = __webpack_public_path__ + "static/media/plus.121042d5.svg";